import WebApp from "@twa-dev/sdk";
import { TELEGRAM_CONFIG } from "../config/app";

/**
 * Инициализация Telegram Web App с поддержкой темной/светлой темы
 */
export function initTelegramWebApp() {
  if (typeof window === "undefined") return;

  try {
    // Готовим WebApp
    WebApp.ready();
    WebApp.expand();
    
    // Определяем текущую тему пользователя
    const colorScheme = WebApp.colorScheme || "light";
    const isDark = colorScheme === "dark";
    
    // Применяем начальную тему
    applyTheme(isDark);
    
    // Слушаем изменения темы
    WebApp.onEvent("themeChanged", handleThemeChange);
    
    console.log(`[Theme] Initialized with ${colorScheme} mode`);
  } catch (error) {
    console.error("[Theme] Initialization error:", error);
  }
}

/**
 * Обработчик изменения темы
 */
function handleThemeChange() {
  const newScheme = WebApp.colorScheme;
  const isDark = newScheme === "dark";
  
  applyTheme(isDark);
  console.log(`[Theme] Changed to ${newScheme} mode`);
}

/**
 * Применение темы к документу и Telegram WebApp
 */
function applyTheme(isDark) {
  const root = document.documentElement;
  
  if (isDark) {
    root.classList.add("dark");
    WebApp.setBackgroundColor(TELEGRAM_CONFIG.BACKGROUND_COLOR.DARK);
  } else {
    root.classList.remove("dark");
    WebApp.setBackgroundColor(TELEGRAM_CONFIG.BACKGROUND_COLOR.LIGHT);
  }
  
  // Устанавливаем цвет хедера (адаптируется автоматически)
  WebApp.setHeaderColor(TELEGRAM_CONFIG.HEADER_COLOR);
}
